export default function () {
  return {
    pagecontactLoading: false,
  }
}
